import * as React from 'react'

// Minimal shim for @radix-ui/react-focus-scope to avoid build-time resolver issues.
// This does not implement focus trapping; it simply renders children.
export type FocusScopeProps = {
  children?: React.ReactNode
} & Record<string, unknown>

export const FocusScope: React.FC<FocusScopeProps> = ({ children }) => {
  // avoid JSX fragment to keep esbuild simple in shim
  return React.createElement(React.Fragment, null, children)
}

export default {} as unknown as {}


